import { SettingsPermissions } from "@redotech/account-common/permissions";
import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";
import { breadcrumbSlot } from "@redotech/redo-web/breadcrumb";
import {
  TranslatedBreadcrumbLabel,
  TranslatedBreadcrumbLayout,
} from "../../return/returns-breadcrumb-label";

const aiBreadcrumb = breadcrumbSlot();
const generalBreadcrumb = breadcrumbSlot();
const skillsBreadcrumb = breadcrumbSlot();
const knowledgeBreadcrumb = breadcrumbSlot();

export function inAiKnowledgeView(url: string) {
  return url.includes("/ai/knowledge");
}

export const aiSettingsRoutes: PermissionedRouteObject = {
  element: (
    <TranslatedBreadcrumbLayout
      breadcrumb={aiBreadcrumb}
      getLabel={(t) => t("AI")}
    />
  ),
  handle: {
    breadcrumb: aiBreadcrumb,
    breadcrumbNavigate: false,
    permission: SettingsPermissions.SET_AI_SETTINGS,
  },
  path: "ai",
  children: [
    {
      path: "general",
      handle: { breadcrumb: generalBreadcrumb },
      lazy: async () => {
        const { GeneralSettingsPage } = await import("./general");
        return {
          element: (
            <>
              <TranslatedBreadcrumbLabel
                breadcrumb={generalBreadcrumb}
                getLabel={(t) => t("General")}
              />
              <GeneralSettingsPage />
            </>
          ),
        };
      },
    },
    {
      path: "skills",
      handle: { breadcrumb: skillsBreadcrumb },
      lazy: async () => {
        const { SkillsSettingsPage } = await import("./skills");
        return {
          element: (
            <>
              <TranslatedBreadcrumbLabel
                breadcrumb={skillsBreadcrumb}
                getLabel={(t) => t("Skills")}
              />
              <SkillsSettingsPage />
            </>
          ),
        };
      },
    },
    {
      path: "knowledge",
      handle: { breadcrumb: knowledgeBreadcrumb },
      lazy: async () => {
        const { AgentKnowledgePage } =
          // redont-allow-dynamic-import: route-level code splitting
          await import("@redotech/redo-merchant-agent-knowledge-app/page");
        return {
          element: (
            <>
              <TranslatedBreadcrumbLabel
                breadcrumb={knowledgeBreadcrumb}
                getLabel={(t) => t("Knowledge")}
              />
              <AgentKnowledgePage />
            </>
          ),
        };
      },
    },
  ],
};
